const stringify = require("@brillout/json-s/stringify");
const parse = require("@brillout/json-s/parse");

module.exports = { stringify, parse };
